// extracted by mini-css-extract-plugin
export default {"page":"Product_page__1HHbb"};